import { HttpResponse } from '@angular/common/http';
import { PreloaderService } from './../../_services/Preloader.service';
import { ToasterService } from './../../_services/Toaster.service';
import { Component, OnInit } from '@angular/core';
import { _userServicesService } from 'src/app/_services/_UserService/_userServices.service';
import { DeviceService } from 'src/app/_services/_DeviceService/Device.service';
import { Device } from 'src/app/_models/Device';
import { User } from 'src/app/_models/User';
import { UserTemplates } from 'src/app/_models/UserTemplates';
import { UserTemplatesService } from 'src/app/_services/UserTemplates/UserTemplates.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-UserTemplates',
  templateUrl: './UserTemplates.component.html',
  styleUrls: ['./UserTemplates.component.css']
})
export class UserTemplatesComponent implements OnInit {

  dataTable = false;
  selectedDeviceFrom: string;
  selectedDeviceTo: string;
  Device: Device[];
  public Users: User[];
  isChecked = false;
  UserIDList: Array<any> = [];
  UserTemplates: UserTemplates[];
  dtOptions: any = {};




  constructor(private SpinnerService: NgxSpinnerService,private UTemplates: UserTemplatesService, private preloader: PreloaderService, private DeviceService: DeviceService, private UserService: _userServicesService, private noti: ToasterService) { }


  ngOnInit() {
    this.preloader.hide();
    this.LoadAllDevices();
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      dom: 'Bfrtip',
        buttons: [
            'copy', 'csv', 'excel', 'pdf', 'print'
        ]
      }
  }
  selectChangeHandlerDeviceFrom(event: any) {
    this.selectedDeviceFrom = event.target.value;
    this.LoadAllUser(this.selectedDeviceFrom);
  }

  LoadAllDevices() {
    this.SpinnerService.show();
    try {
      this.DeviceService.GetActiveDeviceList().subscribe(
        Response => {
          this.SpinnerService.hide();
          if (Response.status == 200) {
            this.Device = Response.body;


          }
          else {
            this.noti.error("Error", Response.body);
          }

        },
        err => {
          this.SpinnerService.hide();
          this.noti.error("Error", err.error);
        }
      );
    } catch (error) {
      this.SpinnerService.hide();
      this.noti.error("Error", "Code Crashed");
    }
  }

  LoadAllUser(Devid: any) {
    this.dataTable = false;
    this.SpinnerService.show();
    this.UTemplates.GetUserTemplates(Devid).subscribe(
      Response => {
        this.SpinnerService.hide();
        if (Response.status == 200) {

          this.UserTemplates = Response.body;
          this.dataTable = true;

        }
      }, error => {
        this.SpinnerService.hide();
        this.noti.error('Something Went Wrong', error);

      });





  }

  DownloadTemplates() {
    if (this.selectedDeviceFrom == "" || this.selectedDeviceFrom == null) {
      this.noti.error('Select Device First', "Error");
    }
    else {
      try {
        this.SpinnerService.show();

        this.dataTable = false;
        this.UTemplates.DownloadTemplates(this.selectedDeviceFrom).subscribe(Response => {
          this.SpinnerService.hide();

          if (Response.status==200) {

            this.noti.success("Success", Response.body);
            this.UserTemplates = Response.body;
            this.dataTable = true;
          }
          else {
            this.noti.error("Error", Response.body);
            this.dataTable = true;
          }

        },
          err => {
            this.SpinnerService.hide();
            this.noti.error("Error", err.error);
            this.dataTable = true;
          }
        );
      } catch (error) {
        this.SpinnerService.hide();
        this.noti.error("Error", "Code Crashed");
        this.dataTable = true;
      }
    }
  }
}
